import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import { ResponseData, SurveyDto } from "./common"

interface SurveyDetailsResponse {
  alreadySurveyed: boolean
  surveyDTO: SurveyDto[]
}
interface GetSurveyParams {
  bookingNumber: string
}

export interface GetSurveyDetailsResponse extends AxiosResponse {
  data: SurveyDetailsResponse
}

export interface GetSurveyRequest extends Partial<AxiosRequestConfig> {
  params: GetSurveyParams
}

export interface SaveSurveyParams {
  Answer1?: string
  Answer2?: string
  Answer3?: string
  Answer4?: number
  Answer5?: number
  Answer6?: string
  Answer7?: {
    selected: string[]
    note: string
  }
  Answer8?: {
    privateToHost: boolean
    answer: string
  }
  bookingNumber: string
  question1?: string
  question2?: string
  question3?: string
  question4?: string
  question5?: string
  question6?: string
  question7?: string
  question8?: string
  bookingRatings?: number | null
}
export interface SaveSurveyRequest extends Partial<AxiosRequestConfig> {
  params: SaveSurveyParams
}

export interface SaveSurveyResponseData extends ResponseData {
  message: string
  status: number
}

export function getSurveyDetailsApi(
  {
    params,
    method = "get",
    url = `/booking/survey/${params.bookingNumber}`,
    ...config
  }: GetSurveyRequest,
  axiosInstance: AxiosInstance,
): Promise<GetSurveyDetailsResponse> {
  return axiosInstance({
    method,
    url,
    ...config,
  }) as Promise<GetSurveyDetailsResponse>
}

export function saveSurveyDetailApi(
  { params }: SaveSurveyRequest,
  axiosInstance: AxiosInstance,
): Promise<SaveSurveyResponseData> {
  const url = `booking/surveydetails/${params.bookingNumber}`

  return axiosInstance({
    data: params,
    method: "post",
    url,
  }) as unknown as Promise<SaveSurveyResponseData>
}
